const rebateList = () =>
  import(/* webpackChunkName: "rebate" */ '@/views/rebate/List.vue')
const rebateDetail = () =>
  import(/* webpackChunkName: "rebate" */ '@/views/rebate/Detail.vue')
export default function (router) {
  // 返佣单列表
  router.push({
    path: '/partner/rebate/list',
    name: 'rebateList',
    component: rebateList,
    meta: {
      keepAlive: true,
      isDistributor: true, // 校验权限是否为渠道商
    },
  })
  // 返佣单详情
  router.push({
    path: '/partner/rebate/detail/:id',
    name: 'rebateDetail',
    component: rebateDetail,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
    },
  })
}
